// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import Vue from "vue";
import App from "./App";
import router from "./router";

import Highcharts from "highcharts";
import loadDrillDown from "highcharts/modules/drilldown";
import loadMap from "highcharts/modules/map.js";
import iView from "iview";
import locale from "iview/dist/locale/en-US";
import VueBootstrapToasts from "vue-bootstrap-toasts";
import fullscreen from "vue-fullscreen";
import VueHighcharts from "vue-highcharts";
import MarqueeText from "vue-marquee-text-component";
import VueNotifications from "vue-notifications";
import * as VueGoogleMaps from "vue2-google-maps";
// Include mini-toaster (or any other UI-notification library)
import miniToastr from "mini-toastr";

// We shall setup types of the messages. ('error' type - red and 'success' - green in mini-toastr)
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

// This step requires only for mini-toastr, just an initialization
miniToastr.init({ types: toastTypes });

// Here we are seting up messages output to `mini-toastr`
// This mean that in case of 'success' message we will call miniToastr.success(message, title, timeout, cb)
// In case of 'error' we will call miniToastr.error(message, title, timeout, cb)
// and etc.
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

// Here we map vue-notifications method to function abowe (to mini-toastr)
// By default vue-notifications can have 4 methods: 'success', 'error', 'info' and 'warn'
// But you can specify whatever methods you want.
// If you won't specify some method here, output would be sent to the browser's console
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

// Activate plugin
// VueNotifications have auto install but if we want to specify options we've got to do it manually.
Vue.use(VueNotifications, options);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API,
    libraries: "places" // necessary for places input
  }
});

Vue.use(iView, { locale: locale });
Vue.use(fullscreen);
Vue.use(VueBootstrapToasts);
Vue.use(BootstrapVue);
// Vue.use(Axios)
loadMap(Highcharts);
loadDrillDown(Highcharts);
Vue.use(Highcharts);
Vue.use(VueHighcharts, { Highcharts });
Vue.component("marquee-text", MarqueeText);

const Axios = axios.create({
  baseURL: process.env.VUE_APP_TRACKER_URL
});

Vue.prototype.$http = Axios;

Vue.prototype.$currentYearDate = new Date().getFullYear() + "-01-01";

Vue.prototype.$formatUSDate = date => {
  return date
    ? date.slice(5, 7) + "/" + date.slice(8, 10) + "/" + date.slice(0, 4)
    : null;
};

Axios.interceptors.request.use(
  config => {
    config.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
    config.headers.common["Accept"] = "application/json";
    const token = localStorage.getItem("fns_token");
    if (token) {
      config.headers.common["Authorization"] = token;
    } else {
      config.headers.common["Authorization"] = "";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
Axios.interceptors.response.use(
  response => {
    if (response.status === 206) {
      router.push("/pages/login");
    }
    return response;
  },
  error => {
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App
  }
});
